import { useMutation } from '@tanstack/react-query'

import chatService from '../services'

import { GenerateChatMediaUploadUrlDtoMediaType } from '@/schema'

interface UploadChatImageResult {
	fileUrl: string
}

export function useMutationUploadChatImage() {
	return useMutation({
		mutationFn: async (file: File): Promise<UploadChatImageResult> => {
			// Get file extension
			const fileExtension = file.name.split('.').pop()?.toLowerCase() || 'jpg'

			// Generate presigned URL
			const { presignedUrl, fileUrl } =
				await chatService.generateMediaUploadUrl({
					mediaType: GenerateChatMediaUploadUrlDtoMediaType.image,
					fileExtension,
				})

			// Upload file to presigned URL
			await chatService.uploadFileToPresignedUrl(presignedUrl, file)

			return { fileUrl }
		},
	})
}
